import theme from 'theme';

export const authLayoutContainerSx = {
  display: 'flex',
  minHeight: '100dvh'
};

export const authBrandingSectionSx = {
  position: 'relative',
  display: 'none',
  width: '50%',
  overflow: 'hidden',
  background: 'linear-gradient(160deg, #1a5c42 0%, #2d7a5f 35%, #4f9b7b 70%, #3a8a6a 100%)',
  animation: 'brandingReveal 0.8s cubic-bezier(0.22, 1, 0.36, 1) both',
  '@keyframes brandingReveal': {
    from: {
      opacity: 0,
      transform: 'translateX(-40px)'
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)'
    }
  },
  '@media (min-width: 1200px)': {
    display: 'flex'
  }
};

export const authBrandingContentSx = {
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
  height: '100%',
  padding: '40px',
  color: 'white',
  '@media (min-width: 1536px)': {
    padding: '56px'
  }
};

export const authBrandingLogoRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px'
};

export const authBrandingHeroSectionSx = {
  maxWidth: '620px'
};

export const authBrandingHeadlineSx = {
  fontWeight: 700,
  lineHeight: 1.15,
  fontSize: `${theme.typography.fontSizeVeryBig}px`
};

export const authBrandingDescriptionSx = {
  marginTop: '24px',
  maxWidth: '480px',
  lineHeight: 1.7,
  color: 'rgba(255, 255, 255, 0.9)'
};

export const authBrandingFeatureListSx = {
  marginTop: '40px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
};

export const authBrandingFeatureItemSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px'
};

export const authBrandingFeatureIconSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  flexShrink: 0
};

export const authBrandingFeatureTextSx = {
  color: 'rgba(255, 255, 255, 0.9)'
};

export const authBrandingCopyrightSx = {
  color: 'rgba(255, 255, 255, 0.9)'
};

export const authFormSectionSx = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '40px 24px',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  '@media (min-width: 600px)': {
    padding: '40px 48px'
  },
  '@media (min-width: 1200px)': {
    width: '50%',
    padding: '40px 48px'
  }
};

export const authFormWrapperSx = {
  width: '100%',
  maxWidth: '460px'
};

export const authMobileHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '40px',
  '@media (min-width: 1200px)': {
    display: 'none'
  }
};

export const authMobileLogoRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px'
};

export const authFormCardSx = {
  borderRadius: '16px',
  backgroundColor: theme.palette.background.paper,
  padding: '24px',
  boxShadow: theme.shadow.popover,
  border: `1px solid ${theme.palette.divider}`,
  '@media (min-width: 600px)': {
    padding: '40px'
  }
};

export const authDesktopLanguageSwitcherSx = {
  display: 'none',
  position: 'absolute',
  top: '24px',
  right: '24px',
  '@media (min-width: 1200px)': {
    display: 'flex'
  }
};
